// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falBan: CreateIconOptions = {
  "displayName": "FALBan",
  "viewBox": "0, 0, 512, 512",
  "d": "M402.7 425.3l-316-316C52.6 148.6 32 199.9 32 256c0 123.7 100.3 224 224 224c56.1 0 107.4-20.6 146.7-54.7zm22.6-22.6C459.4 363.4 480 312.1 480 256C480 132.3 379.7 32 256 32c-56.1 0-107.4 20.6-146.7 54.7l316 316zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
};
